<template>
  <!-- HERO full width (fondo ocupa toda la sección) -->
  <section class="hero">
    <div class="hero__inner">
      <!-- Texto -->
      <div class="hero__copy">
        <h2>PROTEGE A</h2>
        <h1>
          QUIENES <strong>NO PUEDEN&nbsp;HABLAR</strong>
        </h1>
        <p>
          Identificación inteligente con<br />
          NFC y QR para emergencias o<br />
          extravíos.
        </p>
      </div>

      <!-- Mascotas + “capsule” detrás -->
      <div class="hero__pets">
        <img src="../assets/IMG/perro y gatos.png" alt="Perro y gato" />
      </div>
    </div>
  </section>
</template>

<script>
export default { name: "WelcomeView" };
</script>

<style scoped>
/* ====== HERO FULL WIDTH ======
   Esto hace que el fondo se salga del container y ocupe 100% del viewport */
.hero {
  position: relative;
  width: 100vw;            /* ancho completo de pantalla */
  left: 50%;
  margin-left: -50vw;      /* centra el 100vw aunque haya container */
  margin-top: 86px;

  min-height: clamp(580px, 62vw, 860px);
  overflow: hidden;

  background-color: #efefe4;
  background-image: url("../assets/IMG/fondo.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;  /* importante: llena sin deformar */
}

/* Contenido centrado dentro del hero */
.hero__inner {
  position: relative;
  min-height: inherit;
  height: 100%;

  width: 100%;
  margin: 0;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: clamp(22px, 3.2vw, 54px) clamp(10px, 2.8vw, 38px);
}

/* ====== TEXTO ====== */
.hero__copy {
  width: min(560px, 46%);
  margin-left: clamp(22px, 4vw, 72px);
  transform: translateY(36px);
  z-index: 3;
}

.hero__copy h2 {
  color: #ffffff;
  font-family: "Barlow", sans-serif;
  font-size: clamp(36px, 4.8vw, 72px);
  font-weight: 300;
  margin: 0;
  letter-spacing: 0.06em;
  line-height: 1;
  text-transform: uppercase;
}

.hero__copy h1 {
  color: #ffffff;
  font-family: "Barlow", sans-serif;
  font-size: clamp(42px, 6.2vw, 90px);
  font-weight: 400;
  margin: 0;
  line-height: 1;
  text-transform: uppercase;
  letter-spacing: 0.035em;
}

.hero__copy h1 strong {
  font-weight: 700;
}

.hero__copy p {
  font-family: "Barlow", sans-serif;
  color: #ffffff;
  font-weight: 400;
  margin: 18px 0 0;
  font-size: clamp(20px, 2.2vw, 34px);
  line-height: 1.1;
  max-width: 520px;
}

/* ====== MASCOTAS (derecha) ====== */
.hero__pets {
  position: absolute;
  right: -40px;
  bottom: 20px;
  width: min(38%, 500px);
  height: 100%;
  z-index: 2;

  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}

/* “Capsule” clara detrás de las mascotas (como en la referencia) */
.hero__pets::after {
  content: "";
  position: absolute;
  right: -2%;
  bottom: 11%;
  width: 108%;
  height: 56%;
  background: rgba(255, 255, 255, 0.22);
  border-radius: 999px;
  z-index: 1;
}

.hero__pets img {
  position: relative;
  z-index: 2;
  height: 68%;
  width: auto;
  object-fit: contain;
  transform: translateY(14px);
  filter: drop-shadow(0 22px 45px rgba(0, 0, 0, 0.25));
}

/* ====== RESPONSIVE ====== */
@media (max-width: 1200px) {
  .hero {
    min-height: clamp(540px, 64vw, 780px);
  }

  .hero__copy {
    width: min(620px, 58%);
  }

  .hero__pets {
    width: min(42%, 470px);
    right: -24px;
    bottom: 6px;
  }

  .hero__pets img {
    height: 66%;
  }
}

@media (max-width: 900px) {
  .hero {
    min-height: 640px;
  }

  .hero__inner {
    padding: 22px 18px;
  }

  .hero__copy {
    width: 76%;
    margin-left: 12px;
    transform: translateY(24px);
  }

  .hero__copy h2 {
    font-size: clamp(30px, 6.2vw, 50px);
  }

  .hero__copy h1 {
    font-size: clamp(38px, 7.6vw, 66px);
    letter-spacing: 0.025em;
  }

  .hero__copy p {
    max-width: 80%;
    font-size: clamp(18px, 3.5vw, 28px);
  }

  .hero__pets {
    width: 56%;
    bottom: 0;
  }
}

@media (max-width: 768px) {
  .hero {
    margin-top: 78px;
    min-height: 660px;
  }

  .hero__inner {
    align-items: flex-start;
    padding: 24px 14px;
  }

  .hero__copy {
    width: 92%;
    margin-left: 8px;
    transform: translateY(20px);
  }

  .hero__copy h2 {
    font-size: clamp(28px, 7.2vw, 44px);
  }

  .hero__copy h1 {
    font-size: clamp(34px, 10vw, 56px);
    letter-spacing: 0.02em;
  }

  .hero__copy p {
    max-width: 82%;
    font-size: clamp(17px, 4.6vw, 28px);
    margin-top: 12px;
    line-height: 1.12;
  }

  .hero__pets {
    width: 68%;
    right: -30px;
    bottom: -34px;
  }

  .hero__pets::after {
    bottom: 10%;
    height: 50%;
    width: 110%;
  }

  .hero__pets img {
    height: 62%;
    transform: translateY(24px);
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .hero {
    margin-top: 78px;
    min-height: 700px;
  }

  .hero__inner {
    padding: 24px 20px;
  }

  .hero__copy {
    width: 56%;
    margin-left: 20px;
    transform: translateY(-170px);
    text-align: left;
  }

  .hero__copy h2 {
    font-size: clamp(26px, 4.4vw, 36px);
  }

  .hero__copy h1 {
    font-size: clamp(34px, 5.8vw, 52px);
    letter-spacing: 0.02em;
  }

  .hero__copy p {
    max-width: 92%;
    font-size: clamp(16px, 2.6vw, 22px);
  }

  .hero__pets {
    width: 46%;
    right: -10px;
    bottom: -22px;
  }

  .hero__pets::after {
    width: 106%;
    height: 46%;
    bottom: 12%;
  }

  .hero__pets img {
    height: 58%;
    transform: translateY(14px);
  }
}

@media (width: 768px) and (height: 1024px) {
  .hero__copy {
    transform: translateY(50px);
  }
}

@media (max-width: 480px) {
  .hero {
    margin-top: 72px;
    min-height: 650px;
  }

  .hero__copy {
    width: 92%;
    margin-left: auto;
    margin-right: auto;
    transform: translateY(18px);
    text-align: center;
  }

  .hero__copy h1 {
    font-size: clamp(24px, 8.8vw, 34px);
    letter-spacing: 0.012em;
  }

  .hero__copy h2 {
    font-size: clamp(19px, 6.5vw, 28px);
  }

  .hero__copy p {
    max-width: 84%;
    font-size: clamp(13px, 4.4vw, 18px);
    margin-top: 10px;
    margin-left: auto;
    margin-right: auto;
  }

  .hero__pets {
    width: min(56%, 320px);
    left: 95%;
    right: auto;
    transform: translateX(-50%);
    bottom: -40px;
  }

  .hero__pets::after {
    left: 56%;
    right: auto;
    transform: translateX(-50%);
    width: 104%;
    height: 44%;
    bottom: 8%;
  }

  .hero__pets img {
    height: 50%;
    transform: translateY(26px);
  }
}
</style>